import { Dialog, Grid2 } from "@mui/material";
import { useEffect } from "react";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../Hooks/useWorker";
import getDeviceConfig, { configDataId, getConfigId } from "../../../../store/actions/devices/getConfig";
import { devicesDataId, getDevicesId } from "../../../../store/actions/devices/getDevices";
import { repoDataId } from "../../../../store/actions/repositories/getRepositories2";
import { UIactions } from "../../../../store/slices/UI";
import { treesActions } from "../../../../store/slices/trees";
import { warehouseActions } from "../../../../store/slices/warehouse";
import { workerActions } from "../../../../store/slices/workers";
import { groupsTreeId } from "../../../GroupsTraveler/Actions/loadGroupsTree";
import BasicDialogActions from "../../../UI/BasicDialog/BasicDialogActions";
import BasicDialogContent from "../../../UI/BasicDialog/BasicDialogContent";
import BasicDialogTitle from "../../../UI/BasicDialog/BasicDialogTitle";
import Tabs from "../../../UI/GeneralPurpose/Tabs";
import { defaultTab } from "../../../UI/GeneralPurpose/genericIDs";
import { devicePickerId } from "../../../UI/Specialized/DevicePicker";
import { repoPickerId } from "../../../UI/Specialized/RSRepositoryPicker";
import { rootsDataId, tunnelTokenId } from "./Actions/getMachineStatus";
import { postGreylistsId } from "./Actions/postGreylists";
import AllDeSelect from "./Components/AllDeSelect";
import Blocked from "./Components/Blocked/Blocked";
import { passFieldId } from "./Components/Blocked/PassField";
import Close from "./Components/Close";
import SelectDisplay from "./Components/SelectDisplay/SelectDisplay";
import Submit from "./Components/Submit";
import TopBar from "./Components/TopBar/TopBar";

const UIText = {
  "es-CL": { header: "Selección remota" },
  "en-US": { header: "Remote selection" },
};

export const selectionBlockUI = "selectionBlock";

const RemoteSelection = () => {
  const { auth, dispatch, UI, warehouse, settings } = useUIBp();
  // const { done } = warehouse[getConfigId] ?? {};
  const { done } = useWorker(getConfigId) ?? {};
  // const c365devices = useMemo(()=>warehouse[c365devicesListDataId] ?? {}, [warehouse])
  const { payload } = UI.modal;
  const { user } = payload ?? {};
  const devicePicker = UI[devicePickerId] ?? { mid: "" };
  const config = warehouse[configDataId] ?? { config_hash: "", cpassword: "" };
  const { mid } = devicePicker;
  const { header } = UIText[settings.locale];
  const usingCloud = UI[defaultTab]?? 0;

  // console.log("RemoteSelection.js: user", user);

  useEffect(() => {
    const controller = new AbortController();
    if (mid && !done) {
      // const is365machine = !!c365devices[user]
      dispatch(
        getDeviceConfig({
          ...auth,
          controller,
          payload: {
            user,
            machine: mid,
            // is365machine:false,
            token: auth.cloner_key,
          },
        })
      );
    }
    // return () => {
    //   controller.abort();
    // };
  }, [dispatch, auth, user, mid, done]);

  useEffect(() => {
    if (mid && config.config_hash) {
      const value = !!config.cpassword;
      dispatch(UIactions.setValue({ id: selectionBlockUI, value }));
    }
  }, [dispatch, mid, config.config_hash, config.cpassword]);

  useEffect(() => {
    return () => {
      dispatch(UIactions.clear(selectionBlockUI));
      dispatch(UIactions.clear(tunnelTokenId));
      dispatch(UIactions.clear(passFieldId));
      dispatch(treesActions.clearForestWithException(groupsTreeId));
      dispatch(warehouseActions.unload(configDataId));
      dispatch(warehouseActions.unload(rootsDataId));
      dispatch(workerActions.clear(getConfigId));
      dispatch(workerActions.clear(tunnelTokenId));
      dispatch(workerActions.clear(postGreylistsId));
      dispatch(workerActions.clearGroup("root"));
      // controller.abort();
    };
  }, [dispatch]);

  const onClose = (e, reason) => {
    if (reason !== "backdropClick") {
      dispatch(UIactions.closeModal());
    }
  };

  const handleTabChange = (value) => {
    dispatch(UIactions.clear(devicePickerId));
    dispatch(UIactions.clear(repoPickerId))
    dispatch(UIactions.clear(selectionBlockUI));
    dispatch(UIactions.clear(tunnelTokenId));
    dispatch(UIactions.clear(passFieldId));
    dispatch(treesActions.clearForestWithException(groupsTreeId));
    dispatch(warehouseActions.unload(devicesDataId));
    dispatch(warehouseActions.unload(repoDataId));
    dispatch(warehouseActions.unload(configDataId));
    dispatch(warehouseActions.unload(rootsDataId));
    dispatch(workerActions.clear(getDevicesId));
    dispatch(workerActions.clear(getConfigId));
    dispatch(workerActions.clear(tunnelTokenId));
    dispatch(workerActions.clear(postGreylistsId));
    dispatch(workerActions.clearGroup("root"));
  };

  const panels = [
    {
      label: "Cloner",
      tabValue: 0,
      content: (
        <Grid2 container size={12}>
          <TopBar {...{ user }} />
          <Grid2 container size={12}>
            <Blocked />
            <SelectDisplay {...{ user }} />
          </Grid2>
        </Grid2>
      ),
    },
    {
      label: "Cloud",
      tabValue: 1,
      content: (
        <Grid2 container size={12}>
          <TopBar {...{ user, useCloud:true }} />
          <Grid2 container size={12}>
            <Blocked />
            <SelectDisplay {...{ user }} />
          </Grid2>
        </Grid2>
      ),
    },
  ];

  return (
    <Dialog fullWidth {...{ open: true, onClose, maxWidth: "sm" }}>
      <BasicDialogTitle {...{ header }} />
      <BasicDialogContent>
        <Grid2 container {...{ paddingTop: 0.5, sx: { width: "100%" } }}>
          <Tabs {...{ panels, onChange: handleTabChange }} />
        </Grid2>
      </BasicDialogContent>
      <BasicDialogActions>
        {usingCloud?<AllDeSelect {...{user}}/>:null}
        <Close />
        <Submit {...{ user }} />
      </BasicDialogActions>
    </Dialog>
  );
};

export default RemoteSelection;
